import React from 'react';
import { MuseumDetail } from './MuseumDetail';
import { TourDetail } from './TourDetail';
import { PoiDetail } from './PoiDetail';
import './TourContainer.css';

export const TourContainer = ({
  showPreview,
  handleImageClick,
  moveToUserPosition,
  selectedMuseumData,
  selectedTourData,
  selectedPoiData,
  artistRecords
}) => {
  return (
    <div className="tour-container">
      <div className="tour-map">
        {showPreview && (
          <img 
            src="/icons/map_preview_image.svg" 
            alt="Map Preview" 
            className="tour-map__map-preview" 
            onClick={handleImageClick} 
          />
        )}
        <div id="map" className="tour-map__map"></div>
        <img 
          src="/icons/btn_gps.svg" 
          alt="GPS icon" 
          className="tour-map__gps-button" 
          onClick={moveToUserPosition} 
        />
      </div>
      <div className="tour-detail">
        {selectedMuseumData ? (
          <MuseumDetail data={selectedMuseumData} />
        ) : selectedTourData ? (
          <TourDetail data={selectedTourData} artistRecords={artistRecords} />
        ) : selectedPoiData ? (
          <PoiDetail data={selectedPoiData} />
        ) : (
          <div className="tour-detail__no-info-text">
            {showPreview ? '지도를 클릭해 주세요' : '마커를 클릭하여 정보를 확인해 보세요'}
          </div>
        )}
      </div>
    </div>
  );
};